import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=a21244d2&scoped=true&"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=a21244d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21244d2",
  null
  
)

export default component.exports